// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3n1wt","text":"SelectPayment_text__wEsVh","title":"SelectPayment_title__OPWRs","btn":"SelectPayment_btn__2zJzN"};